import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicLayoutComponent } from './dynamic-layout.component';
import { SharedModule } from '../../shared.module';
import { FooterModule } from '../footer/footer.module';
import { HeaderModule } from '../header/header.module';
import { NavigationModule } from '../navigation/navigation.module';
import { OutageBannerModule } from '../outage-banner/outage-banner.module';

@NgModule({
  declarations: [
    DynamicLayoutComponent
  ],
  imports: [
    CommonModule,
    FooterModule,
    HeaderModule,
    NavigationModule,
    SharedModule,
    OutageBannerModule
  ]
})
export class DynamicLayoutModule { }
